const axios = require('axios');
import apiUrl from '../../api.config';

const TAG_API_URL = `${apiUrl}tag`;

const TagService = {
    getBySchool() {
        return axios.get(TAG_API_URL + '/getBySchool');
    },
    add(tagData) {
        return axios.post(TAG_API_URL + '/add', tagData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    update(tagData) {
        return axios.post(TAG_API_URL + '/update', tagData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    delete(tagId) {
        return axios.delete(TAG_API_URL + '/delete/' + tagId, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default TagService;